export const HERO_SLIDE_COUNT = 6;

export const HERO_DESKTOP_IMAGE_SPEC = {
  width: 1920,
  height: 1080,
  aspectRatio: "16 / 9",
  label: "1920 × 1080 px (16:9)",
};

export const HERO_MOBILE_IMAGE_SPEC = {
  width: 1080,
  height: 1620,
  aspectRatio: "2 / 3",
  label: "1080 × 1620 px (2:3)",
};

export const HERO_SLIDE_DEFAULTS = [
  {
    id: "women-bridal",
    image: "/assets/couture/women_bridal.jpg",
    mobile_image: null,
    fallbackSrc: "/assets/couture/women_bridal.jpg",
    bg: "#4a121e",
    tag: "Haute couture / Women",
    title: "Bridal Trousseau",
    subtitle: "Hyderabad atelier / Bespoke bridal",
    description:
      "Handcrafted raw mulberry silks, intricate metallic work and considered proportions for celebrations held close.",
    primary_cta_label: "Explore bridal edit",
    primary_cta_link: "/shop/womens-wear",
    secondary_cta_label: "Custom consultation",
    secondary_cta_link: "/customization",
  },
  {
    id: "men-royal",
    image: "/assets/couture/men_sherwani.jpg",
    mobile_image: null,
    fallbackSrc: "/assets/couture/men_sherwani.jpg",
    bg: "#17372f",
    tag: "Royal atelier / Men",
    title: "Modern Ceremony",
    subtitle: "Tailoring with an Indian point of view",
    description:
      "Structured bandhgalas, refined layers and ceremonial separates shaped with quiet confidence.",
    primary_cta_label: "Explore men's wear",
    primary_cta_link: "/shop/mens-wear",
    secondary_cta_label: "Speak to the atelier",
    secondary_cta_link: "/contact",
  },
  {
    id: "kids-festive",
    image: "/assets/couture/kids_festive.jpg",
    mobile_image: null,
    fallbackSrc: "/assets/couture/kids_festive.jpg",
    bg: "#5b1d36",
    tag: "Festive heirloom / Kids",
    title: "Little Celebrations",
    subtitle: "Light silhouettes for joyful movement",
    description:
      "Gentle silks and lightweight brocades designed thoughtfully for family celebrations and lasting memories.",
    primary_cta_label: "Explore kids wear",
    primary_cta_link: "/shop/kids-wear",
    secondary_cta_label: "Discover our story",
    secondary_cta_link: "/about",
  },
  {
    id: "heritage-drapes",
    image: "/assets/couture/heritage_drape.jpg",
    mobile_image: null,
    fallbackSrc: "/assets/couture/heritage_drape.jpg",
    bg: "#182c40",
    tag: "Signature drapes / Heirloom",
    title: "Heritage Handloom",
    subtitle: "Silver zari, tissue and fluid form",
    description:
      "Expressive drapes and antique-inspired borders reimagined for the modern occasion wardrobe.",
    primary_cta_label: "Shop sarees and drapes",
    primary_cta_link: "/shop/womens-wear/saree-sets",
    secondary_cta_label: "View the collection",
    secondary_cta_link: "/shop",
  },
  {
    id: "occasion-afterglow",
    image: "/assets/editorial_banner.jpg",
    mobile_image: null,
    fallbackSrc: "/assets/editorial_banner.jpg",
    bg: "#351b24",
    tag: "The evening edit / Occasion",
    title: "Afterglow Dressing",
    subtitle: "Fluid silhouettes, rich colour and presence",
    description:
      "A modern occasion chapter designed for entrances, celebrations and evenings that stay in memory.",
    primary_cta_label: "Explore occasion wear",
    primary_cta_link: "/shop/womens-wear",
    secondary_cta_label: "Find your look",
    secondary_cta_link: "/contact",
  },
  {
    id: "atelier-craft",
    image: "/assets/story_craft.jpg",
    mobile_image: null,
    fallbackSrc: "/assets/story_craft.jpg",
    bg: "#443026",
    tag: "Inside the house / Craft",
    title: "Made with Intention",
    subtitle: "Indian craft, composed for now",
    description:
      "A closer look at the hands, textures and considered details behind every Lalita Soujanya piece.",
    primary_cta_label: "Discover our craft",
    primary_cta_link: "/about",
    secondary_cta_label: "Speak to the studio",
    secondary_cta_link: "/contact",
  },
];

export function normalizeHeroSlides(slides, count = HERO_SLIDE_COUNT) {
  const saved = Array.isArray(slides) ? slides : [];
  return HERO_SLIDE_DEFAULTS.slice(0, count).map((fallback, index) => ({
    ...fallback,
    ...(saved[index] || {}),
    id: saved[index]?.id || fallback.id,
    fallbackSrc: fallback.fallbackSrc,
  }));
}
